import React from "react";
import Header from "grommet/components/Header";
import Box from "grommet/components/Box";
import Search from "grommet/components/Search";

export default () => <Header splash={false} float={false} fixed={false} />;



// WEBPACK FOOTER //
// ./src/components/Header.js